import React from 'react'
import { useState, useEffect } from 'react';
import 'dayjs/locale/en'; // optional, based on your locale
import calender from "../../assets/images/calender.png";
import Datetime from 'react-datetime';
import moment from 'moment';
import axiosInstance from '../../helpers/axios';
import { TablePagination,Box,Tabs, Tab,Typography  } from "@mui/material";
import InstituteAutocomplete from '../../components/status/ProjectTable/InstituteSearch';
import search from "../../assets/images/search.png";
import CircularProgress from '@mui/material/CircularProgress';
import { userActions } from '../../actions/user.actions';
import { useDispatch, useSelector } from "react-redux";
import PercentageReport from './PercentageReport';
import { useCurrentUser } from '../../hooks/useCurrentUser';




export default function RollBackReport() {
     const dispatch = useDispatch();
  const decode = useCurrentUser();
  const user = null;
  const productTypeSelected = useSelector((state) => state.ProductTypeFilter.selectedProductType);
    const[snapshotDate,setSnapshotDate]=useState('')
    const [tabIndex, setTabIndex] = useState(0);
     const [data, setData] = useState('')
     const [dataDetails,setDataDetails] = useState([])
     const [ColBucket,setColBucket]=useState('')
     const [rowBucket,setRowBucket]=useState('')
     const [rowsPerPage, setRowsPerPage] = useState(50); 
     const [page, setPage] = useState(0);
    const [isLoading, setIsLoading] = useState(false); 
     const [selectedCell, setSelectedCell] = useState({
        rowBucket: null,
        colBucket: null,
    });
    const [id,setId]=useState(null)

     

     let monthEndDate = null;

      if (snapshotDate) {
        const parsedDate = moment(snapshotDate, ["MMMM YYYY", "YYYY-MM"], true);
        if (parsedDate.isValid()) {
          monthEndDate = parsedDate.endOf("month").format("YYYY-MM-DD");
        }
      }


     useEffect(() => {

        const storedIndex = sessionStorage.getItem("selectedTabIndex");
         if (storedIndex !== null) {
            setTabIndex(parseInt(storedIndex, 10));
          }
   
        const prevMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
     
         let queryParams = {};
     
     
         if (prevMonthEndDate) {
           queryParams.snapshotMonth = prevMonthEndDate;
           
         }
       if (productTypeSelected && productTypeSelected !== "all") {
         queryParams.loanType = Number(productTypeSelected);
       }
     
         axiosInstance.get('/analytics/get-rollback-data', {
           headers: {
           },
           params: queryParams // Pass the query params here
         })
         .then((res) => {
           setData(res?.data?.data);
         })
         .catch((error) => {
         });     
       
     }, [productTypeSelected]); 


    const handleCellClick = (rowBucket, colBucket, value) => {
      setIsLoading(true)
        setColBucket(colBucket)
        setRowBucket(rowBucket)
        setSelectedCell({ rowBucket, colBucket });
      
         let queryParams = {};
         const prevMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
       if (monthEndDate) {
          queryParams.snapshotMonth = monthEndDate;
        } else {
          queryParams.snapshotMonth = prevMonthEndDate;
        }
    

         if (rowBucket) {
           queryParams.bucketFrom = rowBucket ;
           
         }

          if (colBucket) {
           queryParams.bucketTo = colBucket ;
           
         }
          if(id){
          queryParams.instituteId = id
        }
      if (productTypeSelected && productTypeSelected !== "all") {
        queryParams.loanType = Number(productTypeSelected);
      }
     
         axiosInstance.get('/analytics/get-rollback-data-details', {
           headers: {
           },
           params: queryParams 
         })
         .then((res) => {
           setDataDetails(res?.data?.data);
           setIsLoading(false)
         })
         .catch((error) => {
         });     
  
      }

   const tdStyleBase = {
    fontSize: "14px",
    cursor: "pointer",
    width: "10em",
    fontFamily: "Inter-Medium",
    color: "#667085",
    textAlign: "center",
    padding: "6px 4px",
  };

  const getStyle = (row, col) => {
    const isSelected =
      selectedCell.rowBucket === row && selectedCell.colBucket === col;
    return {
      ...tdStyleBase,
      backgroundColor: isSelected ? "#d3e5ff" : "transparent",
      border: isSelected ? "1px solid #3b82f6" : "none",
      borderRadius: isSelected ? "4px" : "0",
    };
  };

  useEffect(() => {
  setPage(0);
}, [dataDetails]);

const handleChangeRowsPerPage = (event) => {
  const value = parseInt(event.target.value, 10);
  setRowsPerPage(value);
  setPage(0);
};

const handleChangePage = (_, newPage) => {
  setPage(newPage);
};


const paginatedData =
  rowsPerPage === -1
    ? dataDetails
    : dataDetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);



     const handleInputChange = (id) => {
        setIsLoading(true)
        let queryParams = {}
        const prevMonthEndDate = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');    

      if (monthEndDate) {
          queryParams.snapshotMonth = monthEndDate;
        } else {
          queryParams.snapshotMonth = prevMonthEndDate;
        }
        if(id){
          queryParams.instituteId = id
        }
       if (productTypeSelected && productTypeSelected !== "all") {
         queryParams.loanType = Number(productTypeSelected);
       }
         if (rowBucket) {
           queryParams.bucketFrom = rowBucket ;
           
         }

          if (ColBucket) {
           queryParams.bucketTo = ColBucket ;
           
         }
        
    
        axiosInstance.get('/analytics/get-rollback-data',{
          params:queryParams,
          headers: {
          },
        }).then((res) => {
           setData(res?.data?.data);
            setIsLoading(false);
         }).catch((error) => {
          alert(error?.response?.data?.message)
          console.error("Error fetching filtered data:", error);
        });
    
    };



    const handleClearFilter =()=>{
      window.location.reload()
    }


     const handleLoanProfile = (loanId,legacyLoanId)=>{
        dispatch({ type: 'SET_LOAN_CONTEXT', payload: { loanid: loanId, legacyLoanId: legacyLoanId } });
        const urlUsers = `/loan-repayment/profile?loanId=${loanId}`;
        const callDetailsUrl = `/call-history/details?loanId=${loanId}`;
        // const urlGetReminder=`/call-history/reminder-details?loanId=${loanId}`
        const emihistoryUrl=`/emis/for-loan?loanId=${loanId}`
    
        dispatch(userActions.fetchCallDetails(callDetailsUrl, user),[])
        dispatch(userActions.fetchLoanDetails(urlUsers, user),[])
        // dispatch(userActions.getReminder(urlGetReminder))
        dispatch(userActions.getEmiHistory(emihistoryUrl,user))
    
      
        window.open(`/Loanprofile?loanId=${loanId}&legacyLoanId=${legacyLoanId}`, "_blank");  }


         const handleChange = (event, newValue) => {
           setTabIndex(newValue);
          sessionStorage.setItem("selectedTabIndex", newValue);
       };


  return (
     <div style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>

       <div
              style={{
                marginTop: '5px',
                padding: '24px',
                border: '1.5px solid #D0D5DD',
                borderRadius: '12px',
                backgroundColor: '#F9FAFB',
                boxShadow: '0 4px 10px rgba(0, 0, 0, 0.05)',
                marginLeft: 'auto',
                marginRight: 'auto',
                borderColor:'#f0f1f1ff',
                minHeight:'100vh'
              }}
            >        

      <Box sx={{ width: '100%',marginTop:'-5px' }}>
      <Tabs value={tabIndex} onChange={handleChange} aria-label="report tabs">
        <Tab label="RollRate Report" />
        <Tab label="Percentage Report" />
      </Tabs>
       <Box sx={{ p: 2 }}>
      {tabIndex === 0 && (
        <Typography variant="body1">
         
            <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',           
                      alignItems: 'center',       
                      gap: '16px',              
                      marginBottom: '20px',
                      justifyContent: 'flex-start',
                    }}
                  >

            <div
              style={{
                height: '30px',
                width: '15em',
                borderRadius: '20px',
                flexShrink: 0,
              }}
            >
                            <Datetime
                  closeOnSelect={false}
                  dateFormat="YYYY-MM"
                  timeFormat={false}
                  onChange={(event) => {
                    if (event && event.format) {
                      setSnapshotDate(event.format("MMMM YYYY"));
                    } else {
                      setSnapshotDate("");
                    }
                  }}
                  locale="en-gb"
                  isValidDate={(currentDate) => {
                    // Allow current month and all past months, disable only future months
                    return currentDate.isSameOrBefore(moment(), "month");
                  }}
                  inputProps={{
                    placeholder: "Select Snapshot Month",
                    style: {
                      height: "36px",
                      fontFamily: "Inter-Medium",
                      backgroundImage: `url(${calender})`,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "5px center",
                      backgroundSize: "15px 15px",
                      paddingLeft: "30px",
                      fontSize: "14px",
                      color: "#000",
                      border: "1px solid #ccc",
                      borderRadius: "7px",
                      width: "100%",
                      marginTop: "2px",
                    },
                    value: snapshotDate,
                  }}
                />
            </div>

  {/* Autocomplete */}
                  <div
                    style={{
                      height: '36px',
                      fontFamily: 'Inter-Medium',
                      display: 'flex',
                      alignItems: 'center',
                      flexShrink: 0,
                    }}
                  >
                    <InstituteAutocomplete
                      onInstituteSelect={(id) => setId(id)}
                      searchIcon={search}
                      placeholder={
                        decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                          ? 'Product Type'
                          : 'Merchant Name'
                      }
                      handleInputChange={handleInputChange}
                      customSx={{ minWidth: 230 }}
                      height={'36px'}
                      borderColor={'#CACCCE'}
                      backgroundColor={'white'}
                    />
                  </div>

                  {/* Button */}
                  <div style={{ flexShrink: 0 }}>
                    <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '130px',
                        backgroundColor: '#D22129',
                        height: '34px',
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter-Medium",
                        paddingLeft: '10px',
                        marginTop: '10px',
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() => { handleInputChange(id)}}
                    >
                      Search Results
                    </button>
                  </div>

                   <div style={{ flexShrink: 0 }}>
                    <button
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '130px',
                        backgroundColor: '#D22129',
                        height: '34px',
                        borderStyle: 'none',
                        borderRadius: "5px",
                        color: 'white',
                        fontFamily: "Inter-Medium",
                        paddingLeft: '10px',
                        marginTop: '10px',
                        whiteSpace: 'nowrap',
                      }}
                      onClick={() => {handleClearFilter() }}
                    >
                     Clear Filter
                    </button>
                  </div>
                </div>

           <div   style={{
                  marginTop: '20px',
                  marginRight: '10px',
                  borderRadius: '12px',
                  borderStyle: 'solid',
                  borderColor: '#ffffffff',
                  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.06)',
                  backgroundColor: '#f9f9f9',
                  padding: '20px',
                }}>
                 {isLoading ? (
                  <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                  <CircularProgress />
                </Box>
                ):
                 <table className='tables' style={{ marginRight: '10px',marginTop:'20px', borderRadius: '5px',boxShadow:"0 4px 10px rgba(0, 0, 0, 0.05)" }}>
              <thead className='table-heading'>
                <tr>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium", paddingLeft: '10px' }}>From Bucket</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>Current</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>s1 (1-30)</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>s2 (31-60)</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>s3 (61-90)</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>m1 (91-120)</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>m2 (121-180)</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>m3 (180+)</th>
                  <th style={{ fontSize: '14px', cursor: 'pointer', width: '10%', fontFamily: "Inter-Medium" }}>Written Off</th>
                </tr>
              </thead>

              <tbody className="table-body">
                  {Array.isArray(data) &&
                    data?.map((item, index) => (
                      <tr className="table-row" key={index} style={{ lineHeight: "25px" }}>
                        <td
              style={getStyle(item.from_bucket, 'from_bucket')}
              onClick={() =>
                handleCellClick(item.from_bucket, 'Current', item?.from_bucket ?? 0)
              }
            >
              {item.from_bucket ?? 0}
            </td>

                        <td
                            style={getStyle(item.from_bucket, 'Current')}
                          onClick={() =>
                            handleCellClick(item.from_bucket, "Current", item?.Current ?? 0)
                          }
                        >
                          {item?.Current ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "s1 (1-30)")}
                          onClick={() =>
                            handleCellClick(item.from_bucket, "s1 (1-30)", item?.s1 ?? 0)
                          }
                        >
                          {item?.s1 ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "s2 (31-60)")}
                          onClick={() =>
                            handleCellClick(item.from_bucket, "s2 (31-60)", item?.s2 ?? 0)
                          }
                        >
                          {item?.s2 ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "s3 (61-90)")}
                          onClick={() =>
                            handleCellClick(item.from_bucket, "s3 (61-90)", item?.s3 ?? 0)
                          }
                        >
                          {item?.s3 ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "m1 (91-120)")}
                          onClick={() =>
                            handleCellClick(item.from_bucket, "m1 (91-120)", item?.m1 ?? 0)
                          }
                        >
                          {item?.m1 ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "m2 (121-180)")}
                          onClick={() =>
                            handleCellClick(item.from_bucket, "m2 (121-180)", item?.m2 ?? 0)
                          }
                        >
                          {item?.m2 ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "m3 (180+)")}
                          onClick={() =>
                            handleCellClick(
                              item.from_bucket,
                              "m3 (180+)",
                              item?.m3 ?? 0
                            )
                          }
                        >
                          {item?.m3 ?? 0}
                        </td>

                        <td
                          style={getStyle(item.from_bucket, "writtenoff")}
                          onClick={() =>
                            handleCellClick(
                              item.from_bucket,
                              "writtenoff",
                              item?.writtenoff ?? 0
                            )
                          }
                        >
                          {item?.writtenoff ?? 0}
                        </td>
                      </tr>
                    ))}
                </tbody>
            </table>}

              



             {isLoading ? (
                               <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%'}}>
                               <CircularProgress />
                             </Box>
                             ):<>{paginatedData.length>0?    
                           <>
                  <table className='tables' style={{ backgroundColor: '#f9f9f9ff',marginTop:'30px',borderRadius:'2px'}}>
                  <thead className='table-heading' >
                        <tr>
                          <th style={{ fontSize: '14px', cursor: 'pointer', width: '8px%', fontFamily: "Inter-Medium", paddingLeft: '10px' }}>LoanId</th>
                          <th style={{ fontSize: '14px', cursor: 'pointer', width: '10px%', fontFamily: "Inter-Medium",paddingLeft: '10px' }}>From Bucket</th>
                          <th style={{ fontSize: '14px', cursor: 'pointer', width: '7px%', fontFamily: "Inter-Medium" }}>To Bucket</th>
                          <th style={{ fontSize: '14px', cursor: 'pointer', width: '7px%', fontFamily: "Inter-Medium" }}>Inst Name</th>

                        </tr>
                      </thead>
                    <tbody className="table-body">
                    {paginatedData?.map((item, index) => (
                        <tr className="table-row" key={index} style={{ lineHeight:"25px" ,cursor: "pointer"}}>
                          <td onClick={()=>handleLoanProfile(item.loan_id,item.legacy_loan_id)} style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085', paddingLeft: '10px' }}>{item.legacy_loan_id}</td>
                          <td style={{ fontSize: '14px', cursor: 'pointer', width: '10em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.from_bucket}</td>
                          <td style={{ fontSize: '14px', cursor: 'pointer', width: '7em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.to_bucket}</td>
                          <td style={{ fontSize: '14px', cursor: 'pointer', width: '7em', fontFamily: "Inter-Medium", color: '#667085' }}>{item.name}</td>
                        
                        </tr>
                      ))}
                    </tbody>
                  </table>
                    {dataDetails.length > 0 && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '10px',
                }}
              >
                <TablePagination
                  rowsPerPageOptions={[50, { value: -1, label: "All" }]}
                  component="div"
                  count={dataDetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    "& .MuiTablePagination-select": { marginBottom: "10px" },
                    "& .MuiIconButton-root": { marginBottom: "10px" },
                  }}
                />
              </div>
                       )}
                  </>     
                   :''}</> }

            </div>   
        
        </Typography>
         )}

           {tabIndex === 1 && (
          <Typography variant="body1">
           <PercentageReport/>
          </Typography>
        )}
        </Box>
      </Box>
      </div>
     </div>
  )
}
